<template>
  <div>
    <!-- <Header></Header> -->
    <Header1></Header1>
    <Body></Body>
  </div>
</template>
<script>
// import Header from "./header.vue";
import Header1 from "./header1.vue";
import Body from "./body.vue";
export default {
  data() {
    return {};
  },
  components: {
    // Header,
    Header1,
    Body,
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
</style>